///
/// EarthBrowser - Base File Handler
///
/// Abstract base class for file type handlers
/// Created by Matt Giger on December 17, 2025
/// Copyright (c) 2025 Geodata Labs
///

import type { AppDispatch, RootState } from '@/redux/store'

export interface FileHandlerContext {
	dispatch: AppDispatch
	getState: () => RootState
}

export abstract class BaseFileHandler {
	protected context: FileHandlerContext

	constructor(context: FileHandlerContext) {
		this.context = context
	}

	/**
	 * Check if this handler can process the given file
	 */
	abstract canHandle(file: File): boolean

	/**
	 * Process the file. Returns the created dataset window id, or null
	 * when no window was created (e.g. the file is already open).
	 */
	abstract handleFile(file: File): Promise<string | null>

	/**
	 * Initialize any resources (e.g., workers)
	 */
	abstract initialize(): void

	/**
	 * Clean up resources
	 */
	abstract cleanup(): void
}

